module.exports = __webpack_public_path__ + "img/dxm.60bc7c14.png";